import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/core/service/auth.service';
import { UnsubscribeOnDestroyAdapter } from 'src/app/shared/UnsubscribeOnDestroyAdapter';
import { MatProgressButtonOptions } from 'mat-progress-buttons';
import { IUserAccessRes } from 'src/app/interfaces/user.interface';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit
{
  loginForm: FormGroup;
  submitted = false;
  error = '';
  hide = true;

  loginProgressBtn: MatProgressButtonOptions = {
    active: false,
    text: 'Iniciar sesión',
    spinnerSize: 30,
    raised: true,
    stroked: false,
    buttonColor: 'primary',
    spinnerColor: 'warn',
    fullWidth: true,
    disabled: false,
    customClass: 'login100-form-btn',
    mode: 'indeterminate'
  };

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService
  ) {
    super();
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      email: [
        '',
        [Validators.required, Validators.email, Validators.minLength(5)]
      ],
      password: ['', Validators.required]
    });
  }

  get f() {
    return this.loginForm.controls;
  }

  async login(): Promise<void> {
    this.loginProgressBtn.active = true;
    this.submitted = true;
    this.error = '';

    if (this.loginForm.invalid) {
      this.loginProgressBtn.active = false;
      this.error = 'Usuario y/o contraseña inválido';
      return;
    } else {
      this.authService.login(this.f.email.value, this.f.password.value)
      .subscribe({
        next: (result: IUserAccessRes) => {
          if (result.status) {
            const token = this.authService.currentUserValue.token;
            if (token) {
              this.router.navigate(['/dashboard/main']);
            }
          } else {
            this.error = result.msg;
          }
        },
        error: (err: any) => {
          this.error = err ? err : 'Ocurrió un error';
          this.loginProgressBtn.active = false;
        },
        complete: () => {
          this.loginProgressBtn.active = false;
        }
      });
    }
  }
  
}
